var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "SpTradesTab" },
    [
      _vm.isNewTrade
        ? _c("new-trade")
        : !_vm.isEditTrade && _vm.Programs.length
        ? _c("programs-trade")
        : !_vm.isEditTrade && !_vm.Programs.length
        ? _c("program-empty", { attrs: { icon: "/img/emptyIconProgram.png" } })
        : _c("edit-trade"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }